import { HttpService, WidgetStyle } from '@sdbn/appclient';
import { Component, OnInit } from '@angular/core';
import { ContextChange } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';

const MODE_DAILY = 'dialy';
const MODE_HOURLY = 'hourly';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent extends AbstractWidgetComponent implements OnInit {


  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  hourlyOccupancyUrl: string;

  selectedDate = new Date();
  data: any;

  constructor(
    public translationService: TranslationService,
    private http: HttpService) {
    super();
  }

  ngOnInit() {
    this.loadReport();
  }

  public back() {
    this.selectedDate = new Date(this.selectedDate.getTime() - this.ONE_DAY_DURATION);
    this.loadReport();
  }

  public forward() {
    this.selectedDate = new Date(this.selectedDate.getTime() + this.ONE_DAY_DURATION);
    this.loadReport();
  }

  private loadReport() {

    this.data = null;

    this.http.postWithContext(`${environment.reportingEndpoint}/stationoccupancy`, { date: this.selectedDate, period: 'day' })
      .subscribe(
        response => {
          this.data = response;
        }
      );

  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
